export function getStoredCampaignParams(addPrefix: boolean = false): Record<string, string> {
  try {
    if (typeof window === 'undefined') return {};

    const stored = window.localStorage.getItem('initial_campaign_params');
    const params = stored ? JSON.parse(stored) : {};

    if (!addPrefix) return params;

    // Add 'initial_' prefix to keys
    return Object.entries(params).reduce((acc, [key, value]) => {
      const prefixedKey = key.startsWith('initial_') ? key : `initial_${key}`;
      acc[prefixedKey as string] = value as string;
      return acc;
    }, {} as Record<string, string>);
  } catch (error) {
    console.error('Error reading campaign params from localStorage:', error);
    return {};
  }
}
